import axiosApi from '@apis/axiosApi'
import queryString from 'query-string'

const EP_LOGIN = '/user/dang-nhap'

export const login = (params: { 
  username: string
  password: string
}) => {
  return axiosApi.post(EP_LOGIN, params)
}

export const getUserInfo = () => {
  return axiosApi.get('/user/lay-thong-tin-nguoi-dung')
}

export const getUserDetail = (id: string) => {
  return axiosApi.get(`/user/lay-thong-tin-nguoi-dung/${id}`)
}

export const getMyMenu = () => {
  return axiosApi.get('/user/lay-menu-cua-toi')
}

export const getListUser = (querySt?: any) => {
  const query = querySt ? queryString.parse(querySt) : {}
  return axiosApi.get('/user/lay-danh-sach-nguoi-dung', {
    params: query || {},
  })
}

export const changePassword = ({
  oldPassword,
  newPassword,
  newPasswordRetype,
}: {
  oldPassword: string
  newPassword: string
  newPasswordRetype: string
}) => {
  return axiosApi.post('/user/doi-mat-khau', {
    oldPassword: oldPassword,
    newPassword: newPassword,
    confirmNewPassword: newPasswordRetype,
  })
}

export const getMyProject = () => {
  return axiosApi.get('/user/lay-du-an-cua-toi')
}

export const getMyBranch = () => {
  return axiosApi.get('/user/lay-chi-nhanh-cua-toi')
}

export const changeBranch = (duAnId: number, chiNhanhId: number) => {
  return axiosApi.put(`/user/${duAnId}/${chiNhanhId}/doi-chi-nhanh`)
}

// Biometric Login API
export const loginBiometric = ({
  biometric_token,
  device_id,
}: {
  biometric_token: string
  device_id: string
}) => {
  return axiosApi.post('/user/dang-nhap-sinh-trac-hoc', {
    tokenSinhTracHoc: biometric_token,
    idThietBi: device_id,
  })
}

// Get Biometric Tokens
export const getBiometricToken = () => {
  return axiosApi.get('/user/token-sinh-trac-hoc')
}

// Revoke Biometric Tokens
export const revokeBiometricToken = (device_id?: string) => {
  return axiosApi.post('/user/thu-hoi-token-sinh-trac-hoc', {
    idThietBi: device_id,
  })
}

export const syncUser = () => {
  return axiosApi.get('/user/lay-thong-tin-nguoi-dung')
}
